export function validateCourseAssessmentRow(value: unknown): string | undefined {
  if (!value) return 'Assessment is required';
  return undefined;
}

export function validateCourseDayIndex(value: unknown): string | undefined {
  const numeric = Number(value);
  if (!Number.isFinite(numeric) || !Number.isInteger(numeric) || numeric < 1) {
    return 'Scheduled day must be a positive whole number';
  }
  return undefined;
}
